var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showFullScreenBtn)?_c('div',{staticClass:"full-screen-btn-con"},[_c('Button',{attrs:{"size":"large","icon":_vm.value ? 'md-contract' : 'md-expand'},on:{"click":_vm.handleChange}},[_vm._v(_vm._s(_vm.value ? '退出全屏' : '全屏'))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3ea31cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/components/fullscreen/fullscreen.vue
// module id = null
// module chunks = 